import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import App from './App.vue';

import FirstRoute from './pages/FirstRoute.vue';
import HomeRoute from './pages/HomeRoute.vue';
import SecondRoute from './pages/SecondRoute.vue';

// Define your routes
const routes = [
  { path: '/', component: HomeRoute },
  { path: '/first', component: FirstRoute },
  { path: '/second', component: SecondRoute },
];

// Create the router instance
const router = createRouter({
  history: createWebHistory(),
  routes,
});

const app = createApp(App);
app.use(router);
app.mount('#app');
